import { CLEAR_DEVICE_FILTER, SET_DEVICE_FILTER, SET_DEVICE_PAGE_NUMBER } from '../types';

export const setDeviceFilter = (organizationId) => ({
  type: SET_DEVICE_FILTER,
  payload: organizationId,
});


export const clearDeviceFilter = () => ({
  type: CLEAR_DEVICE_FILTER,
})

export const setDevicePageNumber = (pageNumber) => ({
  type: SET_DEVICE_PAGE_NUMBER,
  payload: pageNumber,
})